import ServiceDeskPage from './ServiceDesk';

export { ServiceDeskPage };
export default ServiceDeskPage;
